export default __webpack_public_path__ + "static/cabinet_office-333cea3def2e7e8707dad3629680727e.png";